/**
 * Wrapper for RTK Query mutations results. 
 * Pass in a callback just like userEffect() to handle results.
 * Takes a pair of dependency arrays to watch for success/error.
 * Returns a function that you should call when you call a mutation trigger to let this know to start watching for changes.
 */
import {useEffect, useRef} from 'react';
export default function useQueryEffect(cb, successWatches, errorWatches){
    const isUserAction = useRef(false);

    // notify parent of success/error
    useEffect(()=>{
        if(isUserAction.current){
            const error = arrFindTruthy(errorWatches); 
            if(error){
                isUserAction.current = false;
                cb(error.data);   
            }else if(arrFindTruthy(successWatches)){
                isUserAction.current = false;
                cb();
            }
        }
    }, [successWatches, errorWatches]);

    function trigger(){
        isUserAction.current = true;
    }

    return trigger;
}

function arrFindTruthy(arr){
    return arr && arr.find(item=>!!item && (typeof item != 'function'));
}